import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "wishlist",
  "use": "wishlist-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"wishlist\"><path d=\"M8 13.5l-6.1-5a4 4 0 0 1 5.2-6.08l.9.77.9-.77a4 4 0 1 1 5.2 6.08l-6.1 5z\" fill=\"none\" stroke=\"currentColor\" fill-rule=\"evenodd\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol